// ############################ Imported from Old UI ###########################

enum KeysCodesConst {
  numpadEnter = 'NumpadEnter',
  enter = 'Enter',
  Backspace = 'Backspace',
}

export default KeysCodesConst;
